import React from 'react';
import BordApp from './components/BordApp';

function App() {
  return <BordApp />;
}

export default App;
